'use client'

import React, { useRef, useEffect, useState } from 'react';
import { Button, Space } from 'antd-mobile'
import intl from 'react-intl-universal'
import './index.less'

const Signature = ({
    width = 400,
    height = 200,
    onSave
}) => {
    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [context, setContext] = useState(null);
    const [isBlank, setIsBlank] = useState(true);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.strokeStyle = '#000';
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
        setContext(ctx);

    }, []);

    const startDrawing = (e) => {
        setIsDrawing(true);
        const canvas = canvasRef.current;
        if (!canvas || !context) return;

        const rect = canvas.getBoundingClientRect();
        const x = e instanceof TouchEvent ? e.touches[0].clientX - rect.left : e.clientX - rect.left;
        const y = e instanceof TouchEvent ? e.touches[0].clientY - rect.top : e.clientY - rect.top;

        context.beginPath();
        context.moveTo(x, y);
    };

    const draw = (e) => {
        if (!isDrawing || !context || !canvasRef.current) return;

        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const x = e instanceof TouchEvent ? e.touches[0].clientX - rect.left : e.clientX - rect.left;
        const y = e instanceof TouchEvent ? e.touches[0].clientY - rect.top : e.clientY - rect.top;

        context.lineTo(x, y);
        context.stroke();
    };

    const stopDrawing = () => {
        isDrawing && setIsBlank(false)
        
        setIsDrawing(false);
        if (context) {
            context.closePath();
        }
    };

    const clearSignature = () => {
        if (!context || !canvasRef.current) return;
        context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        setIsBlank(true)
    };

    const saveSignature = () => {
        if (!canvasRef.current || !onSave) return;
        if (isBlank) return

        const dataUrl = canvasRef.current.toDataURL('image/png');
        onSave(dataUrl);
    };

    return (
        <div className="sign-wrapper">
            <div className='sign-title text-center p10'><b>{intl.get('ele_signature').d('电子签名')}</b></div>
            <div className="sign-map overflow-hidden">
                <canvas
                    ref={canvasRef}
                    width={width}
                    height={height}
                    className="bg-white touch-none"
                    onMouseDown={(e) => startDrawing(e.nativeEvent)}
                    onMouseMove={(e) => draw(e.nativeEvent)}
                    onMouseUp={stopDrawing}
                    onMouseLeave={stopDrawing}
                    onTouchStart={(e) => startDrawing(e.nativeEvent)}
                    onTouchMove={(e) => draw(e.nativeEvent)}
                    onTouchEnd={stopDrawing}
                />
            </div>
            <div className="sign-btn-bar text-center p10">
                <Space className='p10'>
                    <Button
                        onClick={clearSignature}
                        size='small'
                    >
                        {intl.get('clear').d('清除')}
                    </Button>
                    <Button
                        color='primary'
                        onClick={saveSignature}
                        size='small'
                    >
                        {intl.get('save').d('保存')}
                    </Button>
                </Space>

            </div>
        </div>
    );
};

export default Signature; 